import React from 'react'
import { Container, Type, Unit } from './styles'
import { ECheckUpPropertyUnits } from '~/interfaces'

interface IProps {
  type: string
  unit?: ECheckUpPropertyUnits
}

export const Title = ({ type, unit }: IProps): JSX.Element => {
  const hasTypeAndUnit = type && unit
  if (hasTypeAndUnit) {
    return (
      <Container>
        <Type>{type}</Type>
        <Unit>{`(${unit})`}</Unit>
      </Container>
    )
  }

  const hasOnlyType = type
  if (hasOnlyType) {
    return (
      <Container>
        <Type>{type}</Type>
      </Container>
    )
  }

  return <></>
}
